function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
export default function buildParams(config, parameters) {
    var _config_analytics;
    const params = _object_spread({}, config.page ? {
        page: config.page
    } : {}, config.project ? {
        project: config.project
    } : {}, config.userId ? {
        user_id: config.userId
    } : {}, config.release ? {
        release: config.release
    } : {}, (_config_analytics = config.analytics) === null || _config_analytics === void 0 ? void 0 : _config_analytics.parameters, parameters);
    if (Object.keys(params).length === 0) {
        return undefined;
    }
    return params;
}

//# sourceMappingURL=buildParams.js.map